import L from 'leaflet';

/** Leaflet-ikon: farget prikk + seilnummer-etikett. */
export function boatIcon(sail: string, color: string): L.DivIcon {
  return L.divIcon({
    className: '',
    html:
      `<div style="display:flex;align-items:center;gap:4px;white-space:nowrap;transform:translateY(-50%)">` +
      `<span style="width:14px;height:14px;border-radius:50%;background:${color};border:2px solid #fff;box-shadow:0 0 4px rgba(0,0,0,.8);flex:0 0 auto"></span>` +
      `<span style="font:bold 12px system-ui,sans-serif;color:#fff;text-shadow:0 0 3px #000,0 0 3px #000,0 0 3px #000">${sail}</span>` +
      `</div>`,
    iconSize: [0, 0],
    iconAnchor: [7, 0],
  });
}
